import React, { useState } from 'react';
import ConsultationModal from '../../components/ConsultationModal';
import img8 from '../../img/8.png';

function ScalpTreatments() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="min-h-screen">
      <section className="page-hero">
        <div className="absolute inset-0 z-0">
          <img
            src={img8}
            alt="Hair system fitting and blending"
            className="h-full w-full object-cover object-top opacity-40"
          />
          <div className="page-hero-scrim" />
        </div>
        <div className="container relative z-10 mx-auto px-4">
          <p className="section-kicker text-primary-200">Natural finish</p>
          <h1 className="font-display text-5xl font-semibold md:text-6xl">
            Hair System Fitting & Blending
          </h1>
          <p className="mt-5 max-w-2xl text-xl text-white/85">
            Professional placement, cut-in, and blending for a secure system with a natural-looking finish.
          </p>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="container mx-auto px-4">
          <div className="grid gap-12 md:grid-cols-2">
            <div>
              <p className="section-kicker">Fitting services</p>
              <h2 className="section-heading">From placement to wear-ready</h2>
              <div className="space-y-6">
                {[
                  {
                    title: 'System Placement',
                    copy: 'We position and secure your system for comfort, balance, and natural coverage.',
                  },
                  {
                    title: 'Cut-In',
                    copy: 'The system is shaped around your face, desired length, and everyday grooming routine.',
                  },
                  {
                    title: 'Blending',
                    copy: 'We blend the system with your existing hair for a finished result that looks natural.',
                  },
                ].map((item) => (
                  <div key={item.title} className="border-t border-primary-100 pt-5">
                    <h3 className="font-display text-2xl font-semibold text-ink">{item.title}</h3>
                    <p className="mt-2 text-ink-muted">{item.copy}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-surface p-8">
              <h2 className="font-display text-3xl font-semibold text-ink">Appointment includes</h2>
              <ul className="mt-6 space-y-3 text-ink-muted">
                <li>Fit check</li>
                <li>Hairline placement</li>
                <li>Attachment support</li>
                <li>Cut-in and blend</li>
                <li>Care guidance before you leave</li>
              </ul>
              <button
                type="button"
                onClick={() => setIsModalOpen(true)}
                className="mt-8 w-full rounded-full bg-primary-600 px-6 py-3 font-semibold text-white transition duration-300 hover:bg-primary-700"
              >
                Book Fitting
              </button>
            </div>
          </div>
        </div>
      </section>

      <ConsultationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        interest="Hair System Fitting & Blending"
      />
    </div>
  );
}

export default ScalpTreatments;
